import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MetaSetterService } from 'src/app/general/meta-setter.service';
import { Sport } from 'src/app/sport.model';
import { SPORTS } from 'src/app/sports';

import { BlockConfigService } from 'src/app/block-config.service';
import { BlogService } from 'src/app/blog.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BlockConfigurationObject } from 'src/app/block-configuration-object.model';
import { environment } from 'src/environments/environment';
import { LocalisationService } from 'src/app/localisation.service';

@Component({
	selector: 'app-fixture-page',
	templateUrl: './fixture-page.component.html',
	styleUrls: ['./fixture-page.component.scss']
})
export class FixturePageComponent implements OnInit {
	sportCode: string;
	sport: Sport;
	trustedDesc: SafeHtml;
	trustedCopy: SafeHtml;
	matchListConfig: BlockConfigurationObject;

	pageFaqs: Array<{headerText: string, bodyHTML: string}> = [];

	environment = environment;

	constructor(
		private route: ActivatedRoute,
		private metaSetter: MetaSetterService,
		private blockConfig: BlockConfigService,
		private blogService: BlogService,
		private sanitiser: DomSanitizer,
		private localisationService: LocalisationService,
	) {
		this.sportCode = this.route.snapshot.paramMap.get("sport");

		if (localisationService.sportPrioritySort(SPORTS).some(s => s.code === this.sportCode.toUpperCase())) {
			this.sport = SPORTS.find(s => s.code === this.sportCode.toUpperCase());
		}
	}

	ngOnInit(): void {
		this.initialiseFixtureBlock();

		this.route.params.subscribe((data) => {
			if (data.sport && this.sportCode !== data.sport) {
				this.sportCode = data.sport;

				if (this.localisationService.sportPrioritySort(SPORTS).some(s => s.code === this.sportCode.toUpperCase())) {
					this.sport = SPORTS.find(s => s.code === this.sportCode.toUpperCase());
				}

				this.initialiseFixtureBlock();

			}
		});
	}

	initialiseFixtureBlock(): void {
		
		this.retrieveAndSetMetadata();

		this.matchListConfig = {
			...this.blockConfig.getGlobalBlockConfig(),
			sportCode: this.sportCode,
			hideHeader: true,
			defaultTournamentID: "upcoming",
			defaultRoundID: (this.sport?.isSoccer) ? "upcoming" : undefined,
		}
	}

	retrieveAndSetMetadata = (): void => {

		this.blogService.getBetHubSettings(this.sportCode.toUpperCase())
			.subscribe((settings: Record<string, any>) => {
				this.metaSetter.setMeta({
					title: (settings.site_title || settings.sport_league),
					seoTitle: (settings.seo_scheduled_title || settings.sport_league),
					description: settings.seo_scheduled_description,
					metaImageURL: settings.thumbnail?.url || environment.defaultMetaImage,
					canonicalURL: `${environment.canonicalDomain}/sport-hub/${this.sportCode.toLowerCase()}/schedule`,
					// structuredData: structuredData,
				});

				this.trustedDesc = settings.page_description ? this.sanitiser.bypassSecurityTrustHtml(settings.page_description) : null;
				this.trustedCopy = settings.subheading_description ? this.sanitiser.bypassSecurityTrustHtml(settings.subheading_description) : null;
				this.pageFaqs = settings.faqs || [];
			}, () => {
				this.metaSetter.setMeta({
					title: environment.siteTitle,
					description: environment.defaultMetaDescription,
					metaImageURL: environment.defaultMetaImage,
					canonicalURL: `${environment.canonicalDomain}/sport-hub/${this.sportCode.toLowerCase()}/schedule`,
					// structuredData: structuredData,
				})
				this.trustedDesc = null;
				this.trustedCopy = null;
				this.pageFaqs = [];
			})
	}

}
